// The laws of the table, in the order a player tends to meet them. Part of
// the design lock (see src/config/history.ts).
//
// `seal` is the glyph drawn for the law in the Codex, chosen for its shape:
// rest is a ring raised on a level one, the Monad is every ring folded, a
// mirror is a ring turned down, a tide a ring rising in the outer layer.
// `name` is the law's name, as the manual's page and the seal call it. The
// laws themselves are told only in riddle, in src/config/verses.ts.

import type { GlyphKey } from "../domain/rings.ts"

export const LAW_IDS = ["rest", "empty", "fold", "monad", "altar", "run", "burden", "fold-high", "cascade", "mirror", "tide"] as const
export type LawId = (typeof LAW_IDS)[number]

export type LawConfig = { readonly seal: GlyphKey; readonly name: string }

export const LAWS = {
  rest: { seal: "0+0", name: "Rest" },
  empty: { seal: "000", name: "The Empty Column" },
  fold: { seal: "*00", name: "Fold" },
  monad: { seal: "***", name: "The Monad" },
  altar: { seal: "+00", name: "Altars" },
  run: { seal: "++0", name: "Runs" },
  burden: { seal: "-+0", name: "Burden" },
  "fold-high": { seal: "**0", name: "Folds of Folds" },
  cascade: { seal: "*+*", name: "Cascade" },
  mirror: { seal: "0-0", name: "Mirror Columns" },
  tide: { seal: "00+", name: "Tide Columns" },
} as const satisfies Record<LawId, LawConfig>
